/* unplugin-vue-components disabled */import { render } from "./member_index.vue?vue&type=template&id=6ff71f9c"
import script from "./member_index.vue?vue&type=script&lang=js"
export * from "./member_index.vue?vue&type=script&lang=js"

import "./member_index.vue?vue&type=style&index=0&id=6ff71f9c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__